import React, { Component } from 'react';

import ProductClass from '../../../types/ProductClass';
import { modelOf } from '../../../prop-types';
import { observer } from 'mobx-react';
import Product from '../../../models/Product';
import ProductSigns from '../ProductSigns';

@observer
export class ProductImageSigns extends Component {
  render() {
    const { product } = this.props;

    const productForDiscountCalculations =
      product.class === ProductClass.MULTI
        ? product.multi.getChildWithBestDiscount()
        : product;
    if (!productForDiscountCalculations) {
      return null;
    }
    const hasPriceRange =
      product.class === ProductClass.MULTI &&
      product.multi.priceRange &&
      product.multi.priceRange.min !== product.multi.priceRange.max;
    const hasDiscount = productForDiscountCalculations.price_info
      ? productForDiscountCalculations.price_info.is_discount
      : false;
    const discountPropsPercent = productForDiscountCalculations.price_info
      ? productForDiscountCalculations.price_info.discount_percentage
      : 0;

    return (
      <div className="ProductImageSigns">
        <ProductSigns
          dateAdded={product.date_added}
          hasDiscount={hasDiscount}
          discountProps={{
            percent: discountPropsPercent,
            withUpTo: hasPriceRange
          }}
        />
      </div>
    );
  }
}

ProductImageSigns.propTypes = {
  product: modelOf(Product).isRequired
};

export default ProductImageSigns;



// WEBPACK FOOTER //
// ./src/components/product/ProductImageSigns/index.jsx